import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { formatViews, typeLabel } from '@/utils/movie';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link to={`/detail/${movie.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} - 牛牛视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-950/80 text-background-50 text-[11px] font-medium backdrop-blur-sm">
          {typeLabel(movie.type)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-accent-950 text-[11px] font-bold">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-primary-950/85 to-transparent">
          <p className="text-[11px] text-background-100 line-clamp-1">{movie.status}</p>
        </div>
      </div>
      <h3 className="mt-2 text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {movie.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
        {movie.cast.slice(0, 3).join(' / ')}
      </p>
      <p className="mt-0.5 text-xs text-foreground-400 line-clamp-1">
        {movie.year} · {movie.region} · {formatViews(movie.views)}次播放
      </p>
    </Link>
  );
}